import { useEffect, useState } from 'react'
import { Link } from '@tanstack/react-router'
import type { ErrorComponentProps } from '@tanstack/react-router'
import { useI18n } from '../features/i18n/useI18n'

export function RouteErrorPage({ error, reset }: ErrorComponentProps) {
  const { t } = useI18n()
  const path = window.location.pathname
  const myContractors = path === '/marketplace/private-vendors' || path === '/guided-demo' || path === '/marketplace/private-vendors/demo'
  const [reference] = useState(() => `PR-${crypto.randomUUID().replaceAll('-', '').slice(0, 4).toUpperCase()}`)
  const routeError: unknown = error
  useEffect(() => {
    const context = { correlationId: reference, route: path, release: document.documentElement.dataset.release ?? 'unknown', platform: /Capacitor|iPhone|iPad/i.test(navigator.userAgent) ? 'ios' : 'web', workspaceMode: path.includes('demo') ? 'guided_demo' : 'live', failureComponent: myContractors ? 'my_contractors' : 'route' }
    console.error('Authenticated route render failure.', context, routeError)
    window.dispatchEvent(new ErrorEvent('error', { error: routeError }))
  }, [myContractors, path, reference, routeError])
  return (
    <section className="empty-state" role="alert">
      <p className="eyebrow">{t('Something went wrong')}</p>
      <h1>{myContractors ? t('We couldn’t load My Contractors.') : t('We could not load this page')}</h1>
      <p>{myContractors ? t('Try again. If the problem continues, contact PropertyReady Support.') : t('Try again or return to your dashboard.')}</p>
      <p>{t('Reference')}: <span data-i18n-ignore>{reference}</span></p>
      <div className="dialog-actions">
        <button type="button" onClick={reset}>{t('Try again')}</button>
        <Link className="secondary-button button-link" to="/dashboard">{t('Return to Dashboard')}</Link>
      </div>
    </section>
  )
}
